import { ProductDetailsSectionEligibility } from '../Sections/Eligibility/ProductDetailsSectionEligibility';
import { ProductDetailsSectionBenefits } from '../Sections/ProductDetailsSectionBenefits';
import { ProductDetailsSectionFees } from '../Sections/ProductDetailsSectionFees';
import { ProductDetailsSectionGift } from '../Sections/ProductDetailsSectionGift';
import { ProductDetailsSectionHighlights } from '../Sections/ProductDetailsSectionHighlights';
import { ProductDetailsStickyFooter } from '../Sections/StickyFooter/ProductDetailsStickyFooter';
import { StickyNavigationBar } from '../Sections/StickyNavigationBar/StickyNavigationBar';
import { visibleSections } from '../utils/sections';
import {
  hasProductOffers,
  isBenefitsSectionVisible,
  isEligibilitySectionVisible,
  isFeesSectionVisible,
  isHighlightsSectionVisible,
} from '../utils/sectionVisibility/sectionVisibility';
import { SectionBuilder } from './types';

/**
 * Default builder — CC, and every vertical without a builder of its own: the fixed CC sections in
 * their order, each shown only when the product has content for it, with the default sticky nav.
 */
export const buildDefaultSections: SectionBuilder = (props, staticText) => {
  const { product, vertical, pushDataLayer } = props;

  return {
    Navigation: StickyNavigationBar,
    Footer: ProductDetailsStickyFooter,
    sections: visibleSections([
      {
        id: 'offers',
        label: staticText.pd_nav_offers,
        visible: hasProductOffers(product),
        render: () => (
          <ProductDetailsSectionGift
            {...product}
            vertical={vertical}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'highlights',
        label: staticText.pd_nav_highlights,
        visible: isHighlightsSectionVisible(product),
        render: () => (
          <ProductDetailsSectionHighlights
            {...product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'benefits',
        label: staticText.pd_nav_benefits,
        visible: isBenefitsSectionVisible(props),
        render: () => <ProductDetailsSectionBenefits {...props} />,
      },
      {
        id: 'fees',
        label: staticText.pd_nav_fees,
        visible: isFeesSectionVisible(product),
        render: () => (
          <ProductDetailsSectionFees
            {...product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
      {
        id: 'eligibility',
        label: staticText.pd_nav_eligibility,
        visible: isEligibilitySectionVisible(product),
        render: () => (
          <ProductDetailsSectionEligibility
            product={product}
            pushDataLayer={pushDataLayer}
          />
        ),
      },
    ]),
  };
};
